import { Box, makeStyles } from '@material-ui/core';
import { Body2Text, SubTitle2Text } from 'design-system';

const useStyles = makeStyles(() => ({
  content: {
    display: 'flex',
    flexGrow: 1,
    flexFlow: 'column',
    justifyContent: 'center',
  },
}));

const ErrorLayout = (): JSX.Element => {
  const classes = useStyles();

  return (
    <Box className={classes.content} data-testid="error-layout-container">
      <Box display="flex" flexDirection="column" alignItems="center">
        <SubTitle2Text>Oops.. algo salío mal</SubTitle2Text>
        <img
          src="/svg/conection_error.svg"
          alt="conection error"
          data-testid="error-layout-image"
        />
        <Body2Text color="secondary">
          puedes volver en unos minutos e intertarlo
        </Body2Text>
        <Body2Text color="secondary">nuevamente</Body2Text>
      </Box>
    </Box>
  );
};

export default ErrorLayout;
